import { render, staticRenderFns } from "./MainProjectTabs.vue?vue&type=template&id=f6a914ba&scoped=true&"
import script from "./MainProjectTabs.vue?vue&type=script&lang=ts&"
export * from "./MainProjectTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a914ba",
  null
  
)

export default component.exports